module.exports = __webpack_public_path__ + "static/media/Excel.693c19ab.jpg";